export const OUT_OF_STOCK_STATUS = {
  SOLD_OUT: 1,
  REORDER: 2,
  STOCK: 3,
  DISCONTINUED: 4,
}

export function schemaAvailability(variant) {
  if (!variant) return 'https://schema.org/OutOfStock'

  if (Number(variant.quantity_available) > 0) {
    return 'https://schema.org/InStock'
  }

  const status = Number(variant.out_of_stock_status_id)

  if (
    status === OUT_OF_STOCK_STATUS.REORDER ||
    status === OUT_OF_STOCK_STATUS.STOCK
  ) {
    return 'https://schema.org/BackOrder'
  }

  if (status === OUT_OF_STOCK_STATUS.DISCONTINUED) {
    return 'https://schema.org/Discontinued'
  }

  return 'https://schema.org/OutOfStock'
}
